import { useForm } from "@refinedev/antd";
import { IResourceComponentsProps, GetListResponse } from "@refinedev/core";
import { AntdInferencer } from "@refinedev/inferencer/antd";
import Cw8EditWrapper from "components/cw8/Cw8EditWrapper";
import Cw8List from "components/cw8/Cw8List";
import { ChildForm } from "interfaces/schemaDB";

export const FragmentPubsList: React.FC<IResourceComponentsProps<GetListResponse<{}>>> = () => {
    // return <AntdInferencer />;

    const resourceName :string = 'fragmentPub';
    const { id } = useForm();
    const childrenForms : ChildForm[] =[
        
    ]

    return(
        <Cw8EditWrapper
            resourceName = {resourceName}
            id = {id}
            childrenForms = {childrenForms}
        ></Cw8EditWrapper>
    )   
};
